import React from "react";
import { MantineList, MantineListItem } from "../mantine/list";
import {
    IconChevronDown,
    IconChevronUp,
} from "@tabler/icons-react";
import MantineText from "../mantine/text";
import MantineButton from "../mantine/button";
import MantineTitle from "../mantine/title";
import MantinePaper from "../mantine/paper";
import MantineIcons from "../mantine/icons";
import MantineFlex from "../mantine/flex";

export function VerticalMenuItem(props: any) {
    const { open, verticalMenus, handleNavigationRoute, currentUrl, iconRole, toggleSubMenu, activeSubMenu, verticalMenusUsers, onHover, onLeave, hover } = props;

    return (
        <>
            <div className="pt-6 relative" onMouseLeave={onLeave}>
                {(iconRole == "Admin" ? verticalMenus : verticalMenusUsers)?.map((menus: any, index: any) => (
                    <div className={`${iconRole !== "Admin" && 'flex'}`} key={index}>
                        <MantineList className={`${open && hover === menus.id && 'bg-current-secondary-color'}`}>
                            <MantineListItem key={index}>
                                {/* <MantineFlex className="px-4" onClick={() => { !open ? toggleSubMenu(index) : {} }}> */}
                                <MantineFlex className="px-4" onClick={() => { if (!open) toggleSubMenu(index); }}>

                                    <MantineButton justif={"space-between"} variant="transparent" className={`${!open && 'customButton !pl-0'} text-side_bar_color hover:text-white text-[13px] ${open && 'py-5 hover:bg-secondary-color'} ${iconRole == "Admin" && 'pl-6'} ${iconRole != "Admin" && open && '-ml-2'}`}
                                        leftSection={
                                            <MantineIcons iconComponent={menus.src} size={!open ? 20 : 22} className={`text-side_bar_color ${!open && 'hover:bg-secondary-color'} ${open && hover === menus.id && 'text-white'} ${iconRole === "Admin" ?
                                                menus?.menusLink?.find((el: any) => el.route === currentUrl) ? "text-white" : "" : menus.route === currentUrl && "text-white"
                                                }`} variant={"transparent"} />
                                        } onMouseEnter={() => { onHover(menus.id) }} onClick={() => iconRole != "Admin" ? handleNavigationRoute(menus?.route, menus?.id) : {}}>
                                        <div className={`${iconRole === "Admin" ?
                                            menus?.menusLink?.find((el: any) => el.route === currentUrl) ? "text-white" : "" : menus.route === currentUrl && "text-white"
                                            }`}>{!open && menus?.title}</div></MantineButton>
                                    {/* down and up arrow show and hide show functionality start*/}
                                    {!open && menus?.menusLink &&
                                        <MantineIcons
                                            iconComponent={activeSubMenu === index ? IconChevronUp : IconChevronDown}
                                            size={20}
                                            color={`${menus.menusLink?.[index].route == currentUrl ? "white" : "#d6dadf"
                                                }`}
                                            variant="transparent"
                                            stroke={1.5}
                                            style={{ transition: "transform 200ms ease" }}
                                        />
                                    }
                                </MantineFlex>
                                {/* down and up arrow show and hide show functionality end*/}
                                {/* dropdown values start */}
                                {!open && activeSubMenu === index &&
                                    <MantineList withPadding>
                                        {menus?.menusLink?.map((subMenus: any, index: any) => (
                                            <MantineListItem key={index} className={`text-side_bar_color text-[13px] py-2 ml-6 pl-6 cursor-pointer hover:text-white ${subMenus?.route == currentUrl && '!text-white'}`} onClick={() => handleNavigationRoute(subMenus?.route, subMenus?.id)}>{subMenus?.name}</MantineListItem>
                                        ))}
                                    </MantineList>
                                }
                                {/* dropdown values end */}
                            </MantineListItem>
                        </MantineList>
                        {/* hover effect start menu close time*/}
                        {open && hover == menus.id && menus?.menusLink &&
                            <div className=" absolute left-[4.6rem] top-[1.5rem] z-50 w-48 bg-current-primary-color">
                                <div className=" bg-current-secondary-color p-[0.7rem] mb-2">
                                    <MantineTitle order={5} className={`text-white text-[13px] px-3`}>{menus?.title}</MantineTitle>
                                </div>
                                <MantinePaper className="px-4 rounded-none bg-current-primary-color">
                                    {menus?.menusLink?.map((subMenus: any, index: any) => (
                                        <MantineText key={index} className={`py-2 text-side_bar_color text-[13px] hover:text-white cursor-pointer px-4 ${subMenus?.route == currentUrl && '!text-white'}`} onClick={() => handleNavigationRoute(subMenus?.route, subMenus?.id)}>{subMenus?.name}</MantineText>
                                    ))}
                                </MantinePaper>
                            </div>
                        }
                        {iconRole !== "Admin" && open && hover == menus.id &&
                            <div>
                                <div className="z-50 w-36 bg-current-secondary-color" key={index}>
                                    <div className=" bg-current-secondary-color p-[0.7rem]" onClick={() => handleNavigationRoute(menus?.route, menus?.id)}>
                                        <MantineTitle order={5} className={`text-white text-[13px] cursor-pointer`} >{menus?.title}</MantineTitle>
                                    </div>
                                    <MantinePaper className="px-4 rounded-none bg-current-primary-color">
                                        {menus?.menusLink?.map((subMenus: any, index: any) => (
                                            <MantineText key={index} className={`py-2 text-side_bar_color text-[13px] hover:text-white cursor-pointer ${subMenus?.route == currentUrl && '!text-white'}`} onClick={() => handleNavigationRoute(subMenus?.route, subMenus?.id)}>{subMenus?.name}</MantineText>
                                        ))}
                                    </MantinePaper>
                                </div>
                            </div>
                        }
                    </div>
                ))}
            </div >
        </>
    );
}
